import { AlertTriangle, Loader2 } from 'lucide-react';
import type { ReactNode } from 'react';

interface Props {
  title: string;
  detail?: ReactNode;
  tone?: 'neutral' | 'error';
  busy?: boolean;
  action?: { label: string; onClick: () => void };
  secondary?: { label: string; onClick: () => void };
  children?: ReactNode;
}

/** Full-height centred message used for loading, auth and fatal error states. */
export function ScreenMessage({ title, detail, tone = 'neutral', busy, action, secondary, children }: Props) {
  return (
    <div className="flex h-full min-h-[320px] items-center justify-center p-6" role={tone === 'error' ? 'alert' : 'status'}>
      <div className="w-full max-w-md text-center">
        <div className="mb-3 flex justify-center text-faint">
          {busy ? <Loader2 className="size-6 animate-spin" aria-hidden /> : tone === 'error' ? <AlertTriangle className="size-6 text-danger" aria-hidden /> : null}
        </div>
        <h1 className="text-[17px] font-semibold text-ink">{title}</h1>
        {detail ? <p className="mt-1.5 text-[15px] text-dim">{detail}</p> : null}
        {children}
        {action || secondary ? (
          <div className="mt-4 flex justify-center gap-2">
            {action ? (
              <button type="button" className="btn btn-primary" onClick={action.onClick}>
                {action.label}
              </button>
            ) : null}
            {secondary ? (
              <button type="button" className="btn" onClick={secondary.onClick}>
                {secondary.label}
              </button>
            ) : null}
          </div>
        ) : null}
      </div>
    </div>
  );
}
